export const token = (state) => state.auth.token;
export const getRefreshToken = (state) => state.auth.refreshToken;
export const isAuth = (state) => state.auth.isAuth;
